var _a, _b, _c, _d;
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '../styles';
import { InitialGuideHowToDetail } from '../molecules';
import { InitialGuideQA } from '../molecules/initial_guide_qa';
export var InitialGuideLiveDetail = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css(styles.section) },
            React.createElement("div", { className: css(styles.sectionTitle) }, "LEAN BODY LIVE\u3068\u306F\uFF1F"),
            React.createElement("div", { className: css(styles.sectionTitleBorder) }),
            React.createElement("div", { className: css(styles.topImgBox) },
                React.createElement("img", { className: css(styles.topImg), src: "/assets/images/initial_guide/live/live_top.png" })),
            React.createElement("div", { className: css(styles.description) },
                "\u751F\u914D\u4FE1\u3067\u697D\u3057\u304F\u30D5\u30A3\u30C3\u30C8\u30CD\u30B9\u266A",
                React.createElement("br", null),
                "\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u3067\u53C2\u52A0\u3059\u308B\u3068\u697D\u3057\u3081\u308B\u30C1\u30E3\u30C3\u30C8\u6A5F\u80FD\u3082\u5927\u4EBA\u6C17\uFF01\u30A4\u30F3\u30B9\u30C8\u30E9\u30AF\u30BF\u30FC\u3078\u30E1\u30C3\u30BB\u30FC\u30B8\u3084\u8CEA\u554F\u3092\u9001\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\uFF01")),
        React.createElement("div", { className: css(styles.section, styles.noMarginBottom) },
            React.createElement("div", { className: css(styles.howToSection) },
                React.createElement("div", { className: css(styles.sectionTitle) }, "LEAN BODY LIVE\u306E\u4F7F\u3044\u65B9"),
                React.createElement("div", { className: css(styles.sectionTitleBorder) }),
                React.createElement(InitialGuideHowToDetail, { imgSrc: "/assets/images/initial_guide/live/live_participate.png", imgClassObject: styles.liveParticipateImg, stepNumber: 1, title: "\u201C\u53C2\u52A0\u3057\u305F\u3044\u201D\u30DC\u30BF\u30F3\u3092\u62BC\u305D\u3046" }, "\u201D\u53C2\u52A0\u3057\u305F\u3044\u201D\u30DC\u30BF\u30F3\u3092\u62BC\u3059\u3068MY\u30EC\u30C3\u30B9\u30F3\u306B\u4FDD\u5B58\u3055\u308C\u78BA\u8A8D\u3057\u3084\u3059\u304F\u306A\u308A\u307E\u3059"),
                React.createElement("div", { className: css(styles.triangleBox) },
                    React.createElement("div", { className: css(styles.triangle) })),
                React.createElement(InitialGuideHowToDetail, { imgSrc: "/assets/images/initial_guide/live/take_live_lesson.png", imgClassObject: styles.takeLiveLessonImg, stepNumber: 2, title: "\u6642\u9593\u306B\u306A\u3063\u305F\u3089\u30EC\u30C3\u30B9\u30F3\u3092\u53D7\u3051\u3088\u3046" }, "\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u306E\u81E8\u5834\u611F\u3092\u697D\u3057\u307F\u307E\u3057\u3087\u3046\uFF01"),
                React.createElement("div", { className: css(styles.triangleBox) },
                    React.createElement("div", { className: css(styles.triangle) })),
                React.createElement(InitialGuideHowToDetail, { imgSrc: "/assets/images/initial_guide/live/live_chat.png", imgClassObject: styles.liveChatImg, stepNumber: 3, title: "\u30A4\u30F3\u30B9\u30C8\u30E9\u30AF\u30BF\u30FC\u306B\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u9001\u308D\u3046" }, "\u5065\u5EB7\u3084\u30EC\u30C3\u30B9\u30F3\u306B\u3064\u3044\u3066\u6C17\u8EFD\u306B\u8CEA\u554F\u3057\u3066\u307F\u307E\u3057\u3087\u3046\uFF01"))),
        React.createElement("div", { className: css(styles.livePoint) },
            React.createElement("img", { className: css(styles.pointImg), src: "/assets/images/initial_guide/live/live_calendar.png" }),
            React.createElement("div", { className: css(styles.pointText) },
                React.createElement("div", { className: css(styles.pointTitle) }, "\u53C2\u52A0\u3067\u304D\u306A\u304B\u3063\u305F\u30EC\u30C3\u30B9\u30F3\u3082\u30C1\u30A7\u30C3\u30AF\u3067\u304D\u308B\uFF01"),
                React.createElement("div", { className: css(styles.pointDescription) }, "\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u3067\u53C2\u52A0\u3067\u304D\u306A\u304F\u3066\u3082\u30011\u9031\u9593\u306F\u898B\u9003\u3057\u914D\u4FE1\u3092\u3057\u3066\u3044\u307E\u3059\u3002"))),
        React.createElement("div", { className: css(styles.section) },
            React.createElement("div", { className: css(styles.sectionTitle) }, "\u3088\u304F\u3042\u308B\u8CEA\u554F"),
            React.createElement("div", { className: css(styles.sectionTitleBorder) }),
            React.createElement(InitialGuideQA, { question: "\u81EA\u5206\u306E\u59FF\u3092\u30AB\u30E1\u30E9\u3067\u6620\u3059\u5FC5\u8981\u306F\u3042\u308A\u307E\u3059\u304B\uFF1F" }, "LEAN BODY LIVE\u306B\u30D3\u30C7\u30AA\u6A5F\u80FD\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u59FF\u3092\u6620\u3059\u3053\u3068\u306F\u306A\u3044\u306E\u3067\u6C17\u517C\u306D\u306A\u304F\u3054\u53C2\u52A0\u3044\u305F\u3060\u3051\u307E\u3059\u3002"),
            React.createElement(InitialGuideQA, { question: "\u201C\u53C2\u52A0\u3057\u305F\u3044\u201D\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u305F\u30EC\u30C3\u30B9\u30F3\u306F\u3069\u3053\u3067\u78BA\u8A8D\u3067\u304D\u307E\u3059\u304B\uFF1F" }, "MY\u30EC\u30C3\u30B9\u30F3\u306E\u201C\u53C2\u52A0\u4E88\u5B9A\u306ELIVE\u30EC\u30C3\u30B9\u30F3\u201D\u304B\u3089\u78BA\u8A8D\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"))));
};
var styles = StyleSheet.create({
    section: (_a = {
            marginBottom: 40,
            paddingTop: 30,
            paddingLeft: 24,
            paddingRight: 24
        },
        _a[MediaBreakPointUp.MD] = {
            marginBottom: 0,
            paddingLeft: 40,
            paddingRight: 40,
        },
        _a),
    noMarginBottom: {
        marginBottom: 0,
    },
    sectionTitle: {
        textAlign: 'center',
        fontSize: 18,
        fontWeight: 'bold',
        letterSpacing: '1.44px',
        height: 25,
    },
    sectionTitleBorder: {
        border: "3px solid ".concat(Colors.PrimaryDark),
        borderRadius: 3,
        width: 60,
        margin: '12px auto 12px',
    },
    topImgBox: {
        textAlign: 'center',
        marginTop: 35,
        marginBottom: 35,
    },
    topImg: {
        height: 116,
    },
    description: (_b = {
            backgroundColor: Colors.CyanLightest,
            fontSize: 14,
            fontWeight: 400,
            lineHeight: '160%',
            letterSpacing: '0.56px',
            padding: 24,
            marginBottom: 40,
            borderRadius: 10
        },
        _b[MediaBreakPointUp.MD] = {
            marginBottom: 10,
        },
        _b),
    howToSection: (_c = {},
        _c[MediaBreakPointUp.MD] = {
            marginLeft: 60,
            marginRight: 60,
        },
        _c),
    triangleBox: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: 12,
        paddingBottom: 12,
    },
    triangle: {
        borderStyle: 'solid',
        borderWidth: '20px 15px 0',
        borderColor: "".concat(Colors.BackgroundGrayD, " transparent transparent transparent"),
        width: 31,
    },
    liveParticipateImg: {
        height: 216,
    },
    takeLiveLessonImg: {
        height: 124,
    },
    liveChatImg: {
        height: 142,
    },
    livePoint: (_d = {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: Colors.PrimaryLighter,
            marginTop: 30,
            padding: '40px 24px',
            gap: 16
        },
        _d[MediaBreakPointUp.MD] = {
            marginTop: 40,
            marginBottom: 30,
            padding: '40px 60px',
        },
        _d),
    pointImg: {
        height: 114,
    },
    pointText: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        gap: 16,
    },
    pointTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: '1.44px',
    },
    pointDescription: {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '140%',
        letterSpacing: '0.56px',
    },
});
